/**
 * Velocity Factor Hero Slider Enhancements
 * Adds pause indicator and configurable autoplay control
 * for the homepage hero slideshow
 */

document.addEventListener('DOMContentLoaded', function() {
  const slideshow = document.querySelector('slideshow-slides');

  if (!slideshow) {
    console.log('VF Hero Slider: slideshow not found');
    return;
  }

  console.log('VF Hero Slider: initialized');

  // Add pause indicator element
  const pauseIndicator = document.createElement('div');
  pauseIndicator.className = 'slideshow__pause-indicator';
  slideshow.appendChild(pauseIndicator);

  // Track autoplay state
  let autoplayPaused = false;
  let autoplayTimeout;

  // Pause on hover
  slideshow.addEventListener('mouseenter', function() {
    if (slideshow.hasAttribute('data-autoplay') || slideshow.dataset.autoplay === 'true') {
      autoplayPaused = true;

      // Try to pause using Horizon's method
      if (typeof slideshow.pauseAutoplay === 'function') {
        slideshow.pauseAutoplay();
      }

      pauseIndicator.style.opacity = '1';
      console.log('VF Hero Slider: paused on hover');
    }
  });

  // Resume on mouse leave
  slideshow.addEventListener('mouseleave', function() {
    if (slideshow.hasAttribute('data-autoplay') || slideshow.dataset.autoplay === 'true') {
      autoplayPaused = false;

      // Try to resume using Horizon's method
      if (typeof slideshow.resumeAutoplay === 'function') {
        slideshow.resumeAutoplay();
      }

      pauseIndicator.style.opacity = '0';
      console.log('VF Hero Slider: resumed on mouse leave');
    }
  });

  // Pause when user clicks arrow or dot
  const controls = slideshow.querySelectorAll('.slideshow__arrow, .slideshow__pagination .dot, .slideshow__pagination button');

  controls.forEach(control => {
    control.addEventListener('click', function() {
      if (slideshow.hasAttribute('data-autoplay') || slideshow.dataset.autoplay === 'true') {
        // Pause autoplay
        if (typeof slideshow.pauseAutoplay === 'function') {
          slideshow.pauseAutoplay();
        }
        autoplayPaused = true;

        console.log('VF Hero Slider: paused on control click');

        // Resume after 10 seconds of inactivity
        clearTimeout(autoplayTimeout);
        autoplayTimeout = setTimeout(() => {
          if (autoplayPaused) {
            if (typeof slideshow.resumeAutoplay === 'function') {
              slideshow.resumeAutoplay();
            }
            autoplayPaused = false;
            console.log('VF Hero Slider: auto-resumed after 10s');
          }
        }, 10000);
      }
    });
  });

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    // Only trigger if slideshow is in viewport
    const rect = slideshow.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (!isVisible) return;

    if (e.key === 'ArrowLeft') {
      if (typeof slideshow.previousSlide === 'function') {
        slideshow.previousSlide();
      }
      console.log('VF Hero Slider: previous slide (keyboard)');
    } else if (e.key === 'ArrowRight') {
      if (typeof slideshow.nextSlide === 'function') {
        slideshow.nextSlide();
      }
      console.log('VF Hero Slider: next slide (keyboard)');
    }
  });

  // Swipe gesture support (mobile)
  let touchStartX = 0;
  let touchEndX = 0;

  slideshow.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  slideshow.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 50; // minimum distance for swipe

    if (touchEndX < touchStartX - swipeThreshold) {
      // Swiped left - next slide
      if (typeof slideshow.nextSlide === 'function') {
        slideshow.nextSlide();
      } else {
        // Fallback: click next arrow
        const nextArrow = slideshow.querySelector('.slideshow__arrow--next');
        if (nextArrow) nextArrow.click();
      }
      console.log('VF Hero Slider: next slide (swipe left)');
    }

    if (touchEndX > touchStartX + swipeThreshold) {
      // Swiped right - previous slide
      if (typeof slideshow.previousSlide === 'function') {
        slideshow.previousSlide();
      } else {
        // Fallback: click previous arrow
        const prevArrow = slideshow.querySelector('.slideshow__arrow--prev');
        if (prevArrow) prevArrow.click();
      }
      console.log('VF Hero Slider: previous slide (swipe right)');
    }
  }

  // Announce slide changes to screen readers
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'aria-hidden') {
        const slides = slideshow.querySelectorAll('slideshow-slide');
        let currentSlide = 0;

        slides.forEach((slide, index) => {
          if (slide.getAttribute('aria-hidden') === 'false') {
            currentSlide = index + 1;
          }
        });

        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.className = 'slideshow__sr-only';
        announcement.textContent = `Slide ${currentSlide} of ${slides.length}`;

        slideshow.appendChild(announcement);

        // Remove after announcement
        setTimeout(() => announcement.remove(), 1000);
      }
    });
  });

  // Start observing slide changes
  const slides = slideshow.querySelectorAll('slideshow-slide');
  slides.forEach(slide => {
    observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  });

  console.log('VF Hero Slider: all features loaded');
});
